import { PaginatedTaskActionsResponse, TaskActionFilterParams } from "../../interfaces/participant/ParticipantTask";

/**
 * Fetches a paginated and filtered list of task actions for a specific participant.
 * @param participantId The ID of the participant.
 * @param authToken The authorization token for the API request.
 * @param filterParams The parameters for filtering and pagination.
 * @returns A promise that resolves to the paginated list of task actions, or null if an error occurs.
 */
export async function getTaskActionsByParticipant(
    participantId: number,
    authToken: string,
    filterParams: TaskActionFilterParams
): Promise<PaginatedTaskActionsResponse | null> {
    try {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/taskActions/participant/${participantId}`;

        // Build the query string from the filter parameters, ignoring any undefined or null values.
        const params = new URLSearchParams();
        Object.entries(filterParams).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                params.append(key, value.toString());
            }
        });

        const queryString = params.toString();
        const fullUrl = queryString ? `${apiUrl}?${queryString}` : apiUrl;

        const response = await fetch(fullUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            // Your API returns 404 Not Found if no items are found.
            // Returning null is consistent with other functions in this service file.
            console.error(`Failed to fetch task actions: ${response.status} ${response.statusText}`);
            return null;
        }

        const data: PaginatedTaskActionsResponse = await response.json();
        return data;

    } catch (error) {
        console.error("An error occurred while fetching task actions:", error);
        return null;
    }
}